import { createFileRoute } from '@tanstack/react-router'
import { AccountingHome } from '@/features/accounting-home/accounting-home'
export const Route = createFileRoute('/_authenticated/accounting/')({
  component: AccountingHome,
})
